import { useUpdateContactSuggestions } from './useUpdateContactSuggestions'
import { useMeetingExportSuggestions } from './useExportMeetingSuggestions'
import { useSaveTaskSuggestions } from './useSaveTaskSuggestions'

export const useActionSuggestions = () => {
  const exportMeetingSuggestions = useMeetingExportSuggestions()
  const saveTaskSuggestions = useSaveTaskSuggestions()
  const updateContactSuggestions = useUpdateContactSuggestions()

  const allSuggestions = [...exportMeetingSuggestions, ...saveTaskSuggestions, ...updateContactSuggestions]

  return {
    suggestions: allSuggestions,
    exportMeeting: exportMeetingSuggestions,
    saveTask: saveTaskSuggestions,
    updateContact: updateContactSuggestions,
  }
}
